import React from 'react';
import { Star, StarBorder } from '@mui/icons-material/';
import { useTheme } from '@mui/material';
import Rating from 'react-rating';

interface IProps {
  name?: string;
  readOnly: boolean;
  fractions?: number;
  value: number | undefined;
  starSize?: number;
  onChange?: (value: number) => void;
}

export const STAR_SIZE_LARGE = 36;
export const STAR_SIZE_MEDIUM = 24;
export const STAR_SIZE_SMALL = 20;
export const STAR_SIZE_TINY = 16;

const StarRatingComponent = (props: IProps) => {

  const theme = useTheme();
  const fontSize = theme.typography.pxToRem(props.starSize ?? STAR_SIZE_SMALL);

  return (
    <Rating
      start={0}
      stop={5}
      step={1}
      fractions={props.fractions ?? 6}
      initialRating={props.value}
      readonly={props.readOnly}
      quiet={props.readOnly}
      onChange={props.onChange}
      fullSymbol={<Star color={'secondary'} style={{ fontSize }} fontSize={'inherit'} />}
      emptySymbol={<StarBorder style={{ fontSize }} color={'secondary'} fontSize={'inherit'} />}
    />
  );
};

export default StarRatingComponent;
